import { Box, Stack, Button } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { RealProperty } from './realproperty/preview/Index'
import { Booking } from './booking/Index'
import { Product } from './product/Index'

export const Website = () => {
    const nav = useHistory();
    const type = new URLSearchParams(window.location.search).get("type")

    const handleTypeChange = (v) => {
        nav.push(`/campaign/website?type=${v}`)
    }

    return (
        <Box width="100%">
            <Stack flexDirection="row" gap="1rem" mt="0.625rem" mb="1rem">
                <Button variant="contained" onClick={() => handleTypeChange('real-property')}>Real Property Theme</Button>
                <Button variant="contained" onClick={() => handleTypeChange('product')} disabled>Product Theme</Button>
                <Button variant="contained" onClick={() => handleTypeChange('booking')} disabled>Booking Theme</Button>
            </Stack>
            { 
                type === 'real-property' ? <RealProperty/> :
                type === 'product' ? <Product/> :
                type === 'booking' ? <Booking/> :
                <Box>404 Page not found!</Box>
            }
        </Box>
    )
}